__turbopack_context__.v({
  "tab": "nav-tab-glass-module__Mc5N_a__tab",
});
